export function resizeKeepingAspect(image, container, resolution = 1) {
    let { width: containerwidth, height: containerheight } = container;
    let { width: imagewidth, height: imageheight } = image;
    if (!imagewidth || !imageheight) return { width: containerwidth, height: containerheight };
    if (containerheight === 0 || containerwidth === 0) return { width: imagewidth, height: imageheight };
    let width = imagewidth,
      height = imageheight;
    
  
    if (imagewidth > imageheight) {
        if (width > containerwidth) {
          height = (imageheight * containerwidth) / imagewidth;
          width = containerwidth;
        }
        if (height > containerheight) {
          width = (imagewidth * containerheight) / imageheight;
          height = containerheight;
        }
      } else {
        if (height > containerheight) {
          width = (imagewidth * containerheight) / imageheight;
          height = containerheight;
        }
        if (width > containerwidth) {
          height = (imageheight * containerwidth) / imageheight;
          width = containerwidth;
        }
      }
    width = width * resolution;
    height = height * resolution;

    width = Math.trunc(width);
    if(width%2!==0) width--;
    height = (image.height * width) / image.width;
    return { width, height };
  }